import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { EditPolicyComponent } from '../../../../components/forms/dynamic-forms/edit-policy-form/edit-policy.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

import { EditPolicyService } from '../../../../_services/forms/create-account/edit-policy.service';
import { ModalOptions } from '@mapfre-design-library/src/public_api';
import { UserService } from '../../../../_services/user.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, EditPolicyComponent, MapfreModalComponent, MapfreButtonComponent],
  selector: 'app-signup-edit-policy',
  templateUrl: './signup-edit-policy.component.html',
  styleUrls: ['./signup-edit-policy.component.scss'],
})
export class SignupEditPolicyComponent implements OnInit {
  editPolicyInfo: any[];
  whereToFindModalOptions: ModalOptions;

  constructor(
    private editPolicyService: EditPolicyService,
    private userService: UserService
  ) {}

  ngOnInit() {
    const isCommercialAc = this.userService.getCommercialAcFlag();
    if (isCommercialAc) {
      this.editPolicyInfo = this.editPolicyService.getCommercialAcInputs();
    } else {
      this.editPolicyInfo = this.editPolicyService.getInputs();
    }
    this.whereToFindModalOptions = new ModalOptions({
      additionalClasses: 'modal-small center-on-page modal-dialog',
      additionalButtonClasses:
        'no-padding-horizontal link-button red-link commercial-find-pol underlineBQ font-weight-normal',
      animatePosition: 'bottom',
      buttonCopy: 'MODAL_WHERE_CAN_I_LINK',
      modalId: 'helpModal',
      modalTranslateCopy: 'MODAL_WHERE_CAN_I_TITLE',
      typeOfModal: 'default',
      modalName: 'signup-edit_Where_To_Find_Options',
    });
  }
}
